export var filter=function(vue)
{
	//时间过滤器 年-月-日-时-分
	vue.filter('dateTimeFormat', function (date) {
		var date=new Date(date);
	    var year=date.getFullYear();
	    /* 在日期格式中，月份是从0开始的，因此要加0
	     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
	     * */
	    var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
	    var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
    	var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
    	return year+"-"+month+"-"+day+ " " + hours+":"+minutes;
//  	var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		// 拼接
//	    return year+"-"+month+"-"+day+ " " + hours+":"+minutes+":"+seconds;
		
    })
	//时间过滤器 年-月-日
	vue.filter('dayFormat', function (date) {
		var date=new Date(date);
	    var year=date.getFullYear();
	    /* 在日期格式中，月份是从0开始的，因此要加0
	     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
	     * */
	    var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
		// 拼接
	    return year+"/"+month+"/"+day;
   })
   	//时间过滤器 年-月-日
	vue.filter('dayFormatSub', function (date) {
		var date=new Date(date);
	    var year=date.getFullYear();
	    /* 在日期格式中，月份是从0开始的，因此要加0
	     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
	     * */
	    var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
		// 拼接
	    return year+"-"+month+"-"+day;
   })
	//时间过滤器 年(年)月(月)日(日)
	vue.filter('dayFormatZh', function (date) {
		var date=new Date(date);
	    var year=date.getFullYear();
	    /* 在日期格式中，月份是从0开始的，因此要加0
	     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
	     * */
	    var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	    var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
		// 拼接
	    return month+"月"+day+"日";
   })
	// 手机号码隐藏中间四位过滤器
    vue.filter('mobileFilter', function (value) {
		if (value==null)
		{
			return ""
		}
		else if(value.length == 11){
			return `${value.substring(0,3)}****${value.substring(value.length-4)}`
		}
		else if(value.length<11){
			return value
		}
		
	})
	// 身份证号隐藏中间四位过滤器
    vue.filter('IDFilter', function (value) {
		return `${value.substring(0,5)}********${value.substring(value.length-4)}`
	})
    // vue.filter('pwdFilter',function(value){
    // 	var strongRegex = new RegExp("^(?=.{3,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g"); 
	//     var mediumRegex = new RegExp("^(?=.{2,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g"); 
	//     var weakRegex = new RegExp("(?=.{1,}).*", "g"); 
		
	// 	if(strongeRegex.test(value)){
	// 		return "强";
	// 	}
	// 	if(mediumRegex.test(value)){
	// 		return "中";
	// 	}
	// 	if(weakRegex.test(value)){
	// 		return "弱";
	// 	}
    // })
};


// WEBPACK FOOTER //
// ./src/filter/commonfilter.js